<template>
  <div class="time-up">
    <span class="title">
      {{title}}
      <slot name="title"></slot>
    </span>
    <span class="show-time">
      {{date | format('HH:mm:ss SSS')}}
    </span>
  </div>
</template>

<script>

  export default {
    methods: {
      showTime: function () {
        var _this = this
        if (!this.timer) {
          this.timer = new Date().getTime()
        }
        setInterval(() => {
          _this.date += 63
          return _this.date
        },63)
      }
    },
    data() {
      return {
        date: null,
      }
    },
    props: {
      timer: {
        default: new Date().getTime(),
      },
      title: {
        type: [String, Number],
        default: '北斗卫星授时：',
        required: false
      }
    },
    created() {
      this.date = this.timer
      this.showTime()
    },

    name: "timer-up"
  }
</script>

<style scoped>
  .time-up {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// components/timer-up/index.vue